import { Link } from "react-router-dom";
import { FaStar, FaRegStar, FaRegStarHalf } from "react-icons/fa6";
import { PiBasketLight } from "react-icons/pi";

function Product({ item }) {
  console.log(item)
  return (
    <div
      className="group border-[1px] bg-white border-gray-100 p-5 relative"
    >
      <img src={item?.thumbnail} className="mx-auto mb-2 h-64 rounded object-cover" alt="" />
      <div className="flex items-center justify-between">
        <div className="text-sm space-y-1">
          <Link to={item?.id}>
            <p className="font-light capitalize  text-center group-hover:text-primary">
              {item?.title}
            </p>
          </Link>
          <p className="font-semibold">${item?.price}</p>
          <div className="text-warning flex items-center">
            <FaStar />
            <FaRegStar />
            <FaRegStarHalf />
          </div>
        </div>
        <button className="rounded-full bg-gray-50 border-[1px] text-primary p-2 hover:bg-primary hover:text-white">
          <PiBasketLight />
        </button>
      </div>
    </div>
  );
}

export default Product;
